import {CloseOutlined} from '@ant-design/icons';
import {Button, Form, Input} from 'antd';
import {FormInstance} from 'antd/es/form';
import {FormListFieldData} from 'antd/es/form/FormList';
import cn from 'classnames';
import React, {FC} from 'react';

import {CustomSelect} from 'components/form/inputs/custom-select';
import {EWatcherFieldFlag} from 'components/report-configuration/hooks/use-form-fields-manager';

import {
    SETTING_TEMPLATE_TARGET_FORM_DATA_KEY,
    ESettingTemplateTargetFormFields,
    BASE_MAX_VALUE,
} from '../../constants';

export interface ISettingTemplateTargetTableFieldsProps {
    form: FormInstance;
    fields: FormListFieldData[];
    remove: (index: (number | number[])) => void;
    checkWatcherFlag: (index: number, key: string, flag: EWatcherFieldFlag) => boolean;
    checkArrayIndependentWatcherFlag: (fieldKey: string, flag: EWatcherFieldFlag) => boolean;
}

interface IMaxLabelSettingsArg {
    maxValue?: number;
    label: string;
}

export const SettingTemplateTargetTableFields: FC<ISettingTemplateTargetTableFieldsProps> = ({
    form,
    fields,
    remove,
    checkWatcherFlag,
    checkArrayIndependentWatcherFlag,
}: ISettingTemplateTargetTableFieldsProps) => {
    const sort = fields.sort((a, b) => (
        parseInt(form?.getFieldValue([
            SETTING_TEMPLATE_TARGET_FORM_DATA_KEY,
            a.name,
            ESettingTemplateTargetFormFields.numberId,
        ]), 10) > parseInt(form?.getFieldValue([
            SETTING_TEMPLATE_TARGET_FORM_DATA_KEY,
            b.name,
            ESettingTemplateTargetFormFields.numberId,
        ]), 10) ? 1 : -1));

    const validationRulesRequiredWithLabelAndMaxValue = ({maxValue, label}: IMaxLabelSettingsArg) => ([
        {
            required: true,
            message: `Поле '${label}' должно быть заполнены`,
        },
        {
            max: maxValue ?? BASE_MAX_VALUE,
            message: 'Превышено число символов',
        },
    ]);

    return (
        <div className={cn('form-list')}>
            {sort?.map(field => (
                <div
                    key={field.key}
                    className={cn('form-list__items')}
                >
                    <Form.Item
                        style={{width: 245}}
                        label="Номер"
                        name={[field.name, ESettingTemplateTargetFormFields.numberId]}
                        rules={validationRulesRequiredWithLabelAndMaxValue({label: 'Номер'})}
                    >
                        <Input
                            autoComplete="off"
                            placeholder="Введите номер"
                            disabled={checkWatcherFlag(
                                field.name,
                                ESettingTemplateTargetFormFields.numberId,
                                EWatcherFieldFlag.isDisabled,
                            )}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Имя"
                        name={[field.name, ESettingTemplateTargetFormFields.name]}
                        style={{width: 245}}
                        rules={validationRulesRequiredWithLabelAndMaxValue({label: 'Имя'})}
                    >
                        <Input
                            autoComplete="off"
                            placeholder="Введите имя"
                            disabled={checkWatcherFlag(
                                field.name,
                                ESettingTemplateTargetFormFields.name,
                                EWatcherFieldFlag.isDisabled,
                            )}
                        />
                    </Form.Item>
                    <Form.Item
                        style={{width: 245}}
                        label="Описание"
                        name={[field.name, ESettingTemplateTargetFormFields.description]}
                        rules={validationRulesRequiredWithLabelAndMaxValue({label: 'Описание'})}
                    >
                        <Input
                            autoComplete="off"
                            placeholder="Введите описание"
                            disabled={checkWatcherFlag(
                                field.name,
                                ESettingTemplateTargetFormFields.description,
                                EWatcherFieldFlag.isDisabled,
                            )}
                        />
                    </Form.Item>
                    <Form.Item
                        style={{width: 245}}
                        label="Тип поля"
                        rules={[{required: true}]}
                        name={[field.name, ESettingTemplateTargetFormFields.typeId]}
                    >
                        <CustomSelect
                            settings={{
                                showSearch: true,
                                placeholder: 'Выберите тип поля',
                                url: '/lookupValue/DATA_TYPE',
                                labelPath: 'description',
                                isDisabled: checkWatcherFlag(
                                    field.name,
                                    ESettingTemplateTargetFormFields.typeId,
                                    EWatcherFieldFlag.isDisabled,
                                ),
                                valuePath: 'id',
                                triggerOnValueSet: true,
                                formFieldKey: 'typeId',
                                formInstance: form,
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        style={{width: 245}}
                        label="Буква Excel"
                        required
                        name={[field.name, ESettingTemplateTargetFormFields.excelColumn]}
                        rules={[
                            {
                                required: true,
                                message: `Поле 'Буква Excel' должно быть заполнены`,
                            },
                            {
                                pattern: /^[a-zA-Z]+$/,
                                message: 'Данное поле должно содержать только латинские буквы',
                            }
                        ]}

                    >
                        <Input
                            disabled={checkWatcherFlag(
                                field.name,
                                ESettingTemplateTargetFormFields.excelColumn,
                                EWatcherFieldFlag.isDisabled,
                            )}
                            autoComplete="off"
                            placeholder="Введите номер"
                        />
                    </Form.Item>
                    <Form.Item label={<>&nbsp;</>}>
                        <Button
                            className="button-only-icon"
                            type="primary"
                            icon={<CloseOutlined className="svg-icon-size-16" />}
                            disabled={checkArrayIndependentWatcherFlag('removeButton',
                                EWatcherFieldFlag.isDisabled)}
                            onClick={() => remove(field.name)}
                        />
                    </Form.Item>
                </div>
            ))}
        </div>
    );
};
